import { Toast } from '@bp/ui-components';
import * as Sentry from '@sentry/react';
import { LicenseHintHost } from './components/LicenseHint/LicenseHint';
import { AppLayoutContextProvider } from './contexts/AppLayoutContextProvider';
import { EventJobRunningProvider } from './contexts/EventJobRunningContext';
import { UserConfigProvider } from './contexts/StoreContext/UserConfigContext';
import { DataLoader } from './DataLoader';
import { PlanungAuthProvider } from './PlanungAuthProvider';
import { RequireAuth } from './RequireAuth';
import { RequireBackend } from './RequireBackend';
import { UrqlClientProvider } from './UrqlClientProvider';

export const App = Sentry.withProfiler(() => {
  return (
    <PlanungAuthProvider>
      <RequireAuth>
        <RequireBackend>
          <UrqlClientProvider>
            <UserConfigProvider>
              <AppLayoutContextProvider>
                <EventJobRunningProvider>
                  <DataLoader />
                </EventJobRunningProvider>
              </AppLayoutContextProvider>
            </UserConfigProvider>
          </UrqlClientProvider>
          <LicenseHintHost />
        </RequireBackend>
        <Toast />
      </RequireAuth>
    </PlanungAuthProvider>
  );
});
